export enum MachineStatus {
  Active = 1,
  Deactivated = 2
}

export const MachineStatusLabels = {
  [MachineStatus.Active]: "Aktiv",
  [MachineStatus.Deactivated]: "Inaktiv"
}
